import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { CrudAlterarSenhaEtapa1Component } from '../';
import { CrudAlterarSenhaEtapa2Component } from '../';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { concat } from 'rxjs/observable/concat';

@Component({
  selector: 'alterar-senha-crud',
  templateUrl: 'alterar-senha-crud.component.html'
})

export class CrudAlterarSenhaComponent extends BaseCrudComponent {
  controllerName = 'usuario';
  cadastro = this.formBuilder.group({
    senha: [null, [Validators.required]],
    senhaAtual: [null, [Validators.required]],
    novaSenha: [null, [Validators.required]],
    nome: [null],
    email: [null],
    cpf: [null],
    confirmarSenha: [null, [Validators.required]],
    id: [null]
  });
  listaLink: string[];
  init() {
    this.listaLink = location.href.split("/")

    if (localStorage.getItem("token") != null) {
      this.bObservale.getValue.subscribe(
        permissions => {
          if(permissions != "" && permissions && this.listaLink.length == 6){
            var per = permissions.obj;
            this.service.Obter(this.controllerName, per.id).subscribe(obj => {
              this.cadastro.controls["id"].setValue(obj.id);
              this.cadastro.controls["nome"].setValue(obj.nome);
              this.cadastro.controls["email"].setValue(obj.email);
              this.cadastro.controls["cpf"].setValue(obj.cpf);
              this.cadastro.controls["senha"].setValue(null);
              this.cadastro.controls["senhaAtual"].setValue(obj.senha);
            });
          }
        }
      );
    };
  }

  afterLoad(){
    this.cadastro.controls["id"].setValue(this.obj.id);
    this.cadastro.controls["nome"].setValue(this.obj.nome);
    this.cadastro.controls["email"].setValue(this.obj.email);
    this.cadastro.controls["cpf"].setValue(this.obj.cpf);
    this.cadastro.controls["senha"].setValue(null);
    this.cadastro.controls["senhaAtual"].setValue(this.obj.senha); 
    this.cadastro.get('senha').clearValidators();
    this.cadastro.get('senha').updateValueAndValidity();

  }

  validarSenha(valSenha): boolean {
    let maiusculo = "um caracter maiúsculo";
    let minusculo = "um caracter minúsculo";
    let caracter = "um caracter especial";
    let regexCaractereEspecial = '[^a-zA-Z0-9]+';
    let regexNumero = '[0-9]';

    for (let i = 0; i < valSenha.length; i++) {
      if (valSenha.charAt(i).match(regexCaractereEspecial)) {
        caracter = "";
      }
      if (valSenha.charAt(i).toUpperCase() == valSenha.charAt(i) && !valSenha.charAt(i).match(regexNumero) && !valSenha.charAt(i).match(regexCaractereEspecial)) {
        maiusculo = "";
      }
      if (valSenha.charAt(i).toLowerCase() == valSenha.charAt(i) && !valSenha.charAt(i).match(regexNumero) && !valSenha.charAt(i).match(regexCaractereEspecial)) {
        minusculo = "";
      }
    }
    if (maiusculo != "" || minusculo != "" || caracter != "") {
      super.showMsg('warn', 'Mensagem de Sucesso', 'Atenção! A nova senha deve conter pelo menos uma letra maiúscula, uma letra minúscula e um caracter especial.');
      return false;
    } else {
      return true;
    }
  }

  voltar(){
    this.router.navigate(['/usuarios/usuario-externo'])
  }

  finalizar(event: any) {
    if(this.cadastro.valid){
      if(this.acao == 'cadastrar'){
        if (this.validarSenha(this.cadastro.value.novaSenha)) {
          if (this.cadastro.value.novaSenha !== this.cadastro.value.confirmarSenha) {
            super.showMsg('warn', 'Mensagem de Erro', 'Senhas não conferem.');
          } else {
            this.confirmacao.confirm({
              header: 'Mensagem de Confirmação',
              message: `Atenção! Ao confirmar esta operação, a senha será atualizada na base de dados.
                    Deseja realmente confirmar esta operação?`,
              accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.Atualizar(this.controllerName, this.cadastro.getRawValue())
                  .subscribe(
                    sucess => {
                      this.router.navigate(['../sistema/modulos']);
                      super.showMsg('success', 'Mensagem de Sucesso', 'Registro atualizado com sucesso.')
                      this.observableUtilPanelDoc.setBlockedPanel(false);
                    },
                    err => {
                      super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                      this.observableUtilPanelDoc.setBlockedPanel(false)
                    });
              }
            });
          }
        }
      }else{
        if (this.cadastro.value.novaSenha !== this.cadastro.value.confirmarSenha) {
          super.showMsg('warn', 'Mensagem de Erro', 'Senhas não conferem.');
        } else {
          this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, a senha será atualizada na base de dados.
                  Deseja realmente confirmar esta operação?`,
            accept: () => {
              this.observableUtilPanelDoc.setBlockedPanel(true);
              this.service.Atualizar(this.controllerName, this.cadastro.getRawValue())
                .subscribe(
                  sucess => {
                    sessionStorage.setItem("msg", "Registro atualizado com sucesso.");
                    this.router.navigate(['/usuarios/usuario-externo']);
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                  },
                  err => {
                    super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                    this.observableUtilPanelDoc.setBlockedPanel(false)
                  });
            }
          });
        }
      }
    }else{
      this.touchAll(this.cadastro);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/alterar-senha/crud/alterar-senha-crud.component.ts